<template>
  <div class="limiter" v-if="id">
    <div class="image">
      <img src="../assets/logo/logo.png" alt="Logo">
    </div>
    <div class="container-login100">
      <div class="wrap-login100">
        <form class="login100-form validate-form" @submit.prevent="submit">
          <h1>
            <span class="login100-form-title">
              Yango Details
            </span>
          </h1>

          <div class="form-group">
            <label for="contact">Contact Number</label>
            <input id="contact" v-model="form.contact" class="input100"  type="tel" placeholder="Contact Number" required>
          </div>

          <div class="form-group">
            <label for="mobile">Mobile Number</label>
            <input id="mobile" v-model="form.mobile" class="input100"  type="tel" placeholder="Where to send money" required>
          </div>

          <div class="form-group">
            <label for="amount">Amount</label>
            <input id="amount" v-model.number="form.amount" class="input100" step="0.01" type="number" placeholder="Amount" required>
          </div>

          <div class="form-group file-input-container">
            <input
                id="file-nrcPassport"
                class="input100"
                type="file"
                name="image"
                @change="handleFileChange($event, 'image')"
                accept=".pdf,image/*"
            >
            <label for="file-nrcPassport" class="btn-file-input">{{ image || 'Picture of Bill' }}</label>
          </div>

          <button type="submit" class="login100-form-btn">
            Submit
          </button>

        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Swal from "sweetalert2";
import {errorHandler} from "@/services/errorHandler";

export default {
  name: 'Yango',
  data() {
    return {
      form: {
        contact: '',
        mobile: '',
        amount: '',
        file: null,
        fileBase64: '',
      },
      id: this.$route.query.id,
      username: this.$route.query.userName,
      image: '',
    };
  },

  computed: {
    networkType() {
      const mobilePrefix = String(this.form.mobile).slice(0, 3);
      switch (mobilePrefix) {
        case '076':
        case '096':
          return 'MTN_DEPOSIT';
        case '075':
        case '095':
          return 'ZAMTEL_DEPOSIT';
        case '077':
        case '097':
          return 'AIRTEL_DEPOSIT';
        default:
          return null;
      }
    }
  },

  watch: {
    '$route.query.id': function(newId) {
      this.id = newId;
    },
    'form.contact'(newValue) {
      if (newValue) {
        this.form.mobile = newValue;
      }
    }
  },

  methods: {
    async getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },

    async handleFileChange(event, field) {
      const file = event.target.files[0];
      if (file) {
        this.form[field] = file; // Set the file in the form
        try {
          const base64String = await this.getBase64(file);
          this.form.fileBase64 = base64String; // Save the base64 string in the form
          this.image = file.name; // Update the label text
        } catch (error) {
          errorHandler.tomcatError(error)
        }
      }
    },
    logout() {
      this.$store.commit('clearUserData');
      localStorage.removeItem('user');

      this.$router.push(`/login?id=${this.id}`);
    },

    async submit() {
      if (!this.validateForm()) {
        responses.showInfo('Please fill out the form correctly.')
        return;
      }

      const payload = {
        username: this.username,
        dispId: this.id,
        type: 'TRANSIT',
        status: 'Yango',
        contact : this.form.contact,
        accountNumber: this.form.mobile,
        amount: this.form.amount,
        paymentType: this.networkType,
        imageBase64Str: this.form.fileBase64,
      };

      this.$store.commit('setLoadingState', true);
      return this.$store.dispatch('updateState',payload)
        .then(() => {
          this.resetForm();
          responses.showSuccess(`Your information has been submitted!`)
          this.logout()
        })
        .finally(()=> this.$store.commit('setLoadingState', false))
    },

    validateForm() {
      return (
          this.form.contact &&
          this.form.mobile &&
          this.form.amount &&
          !isNaN(this.form.amount) &&
          Number(this.form.amount) > 0 &&
          this.form.fileBase64
      );
    },

    resetForm() {
      this.form = {
        contact: '',
        mobile: '',
        amount: '',
        file: null,
        fileBase64: '',
      };
      this.image = '';
    }
  }
}
</script>
